<template>
    <section v-if="userStore.user" class="invoice-add-wrapper">
        <div class="row invoice-add">
            <div class="col-xl-9 col-md-8 col-12">
                <div class="card invoice-preview-card">
                    <div class="card-body invoice-padding pb-0">
                        <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                            <div>
                                <h5 class="card-text mb-25">
                                    <strong>
                                        {{ localizationStore.translate("first-name") + ' ' + userStore.user.firstname }}
                                    </strong>
                                </h5>
                                <h5 class="card-text mb-25">
                                    <strong>
                                        {{ localizationStore.translate("middle-name") + ' ' + userStore.user.middle_name }}
                                    </strong>
                                </h5>
                                <h5 class="card-text mb-0">
                                    <strong>
                                        {{ localizationStore.translate("last-name") + ' ' + userStore.user.lastname }}
                                    </strong>
                                </h5>
                            </div>
                            <div class="invoice-number-date mt-md-0 mt-2">
                                <div class="d-flex align-items-center justify-content-md-end mb-1">
                                    <h4 class="invoice-title">Invoice</h4>
                                    <div class="input-group input-group-merge invoice-edit-input-group">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text" style="background-color: #efefef;">
                                                <i data-feather="hash"></i>
                                            </div>
                                        </div>
                                        <input
                                            type="text"
                                            class="form-control invoice-edit-input"
                                            placeholder="53634"
                                            :value="invoiceStore.invoice.invoiceNumber"
                                            readonly
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="invoice-spacing" />
                    <div class="card-body invoice-padding pt-0">
                        <div class="row row-bill-to invoice-spacing">
                            <div class="col-xl-6 mb-lg-1 col-bill-to pl-0">
                                <h6 class="invoice-to-title">{{ localizationStore.translate("bill-to") }}</h6>
                                <div class="invoice-customer">
                                    <v-select
                                        v-model="selected"
                                        :options="options"
                                        :get-option-label="(option) => option.creditor_name"
                                        :filterable="false"
                                        placeholder="Select Customer"
                                        @search="onSearch"
                                    >
                                        <!-- :dropdown-should-open="() => true" -->
                                        <template #list-header>
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    btn
                                                    btn-flat-success
                                                    cursor-pointer
                                                    rounded-0
                                                    text-left
                                                    mb-50
                                                    p-50
                                                    w-100
                                                "
                                                data-toggle="modal"
                                                data-target="#add-new-debt-collector-sidebar"
                                            >
                                                <vue-feather type="plus" size="12" class="font-medium-1 mr-25"></vue-feather>
                                                <span class="align-middle">
                                                    Add New Debt Collector
                                                </span>
                                            </div>
                                        </template>
                                        <template #list-footer>
                                            <li class="pagination">
                                                <button type="button" :disabled="page == 1" @click="previous">Prev</button>
                                                <button type="button" :disabled="!hasNextPage" @click="next">Next</button>
                                            </li>
                                        </template>
                                    </v-select>
                                </div>
                                <div v-if="selected" class="customer-details mt-1">
                                    <p class="mb-25">
                                        {{ selected.phone }}
                                    </p>
                                    <p class="mb-25">
                                        {{ selected.address }}
                                    </p>
                                </div>
                            </div>
                            <div class="col-xl-6 pr-0 mt-xl-0 mt-2">
                                <h6 class="mb-2">Payment Details:</h6>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td class="pr-1">
                                                <strong>
                                                    DATE ISSUED: 
                                                </strong>
                                            </td>
                                            <td>
                                                <strong>
                                                    {{ invoiceStore.invoice.date }}
                                                </strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="pr-1">
                                                <strong>
                                                    PAYMENT TERMS: 
                                                </strong>
                                            </td>
                                            <td>
                                                <strong>
                                                    Pay By Check
                                                </strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="pr-1">
                                                <strong>
                                                    DUE DATE: 
                                                </strong>
                                            </td>
                                            <td>
                                                <strong>
                                                    DUE UPON RECEIPT
                                                </strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="pr-1">
                                                <strong>
                                                    BALANCE DUE 
                                                </strong>
                                            </td>
                                            <td>
                                                <strong>$ {{ total }}</strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="card-body invoice-padding invoice-product-details">
                        <div class="source-item">
                            <div v-for="(item, index) in items" class="row mb-3">
                                <div class="col-12 d-flex product-details-border position-relative pr-0">
                                    <div class="row w-100 pr-lg-0 pr-1 py-2">
                                        <div class="col-lg-3 col-12 mb-lg-0 mb-2 mt-lg-0 mt-2">
                                            <p class="card-text col-title mb-md-50 mb-0">Item</p>
                                            <select
                                                v-model="items[index].item_id"
                                                class="form-control"
                                                required
                                            >
                                                <option></option>
                                                <option v-for="(item, id) in invoiceStore.invoice.items" :value="item.id">{{ item.name }}</option>
                                            </select>
                                        </div>
                                        <div class="col-lg-3 col-12 mb-lg-0 mb-2 mt-lg-0 mt-2">
                                            <p class="card-text col-title mb-md-50 mb-0">Violation</p>
                                            <select
                                                v-model="items[index].common_violation_id"
                                                class="form-control"
                                                required
                                            >
                                                <option></option>
                                                <option
                                                    v-if="violations(items[index].item_id) && violations(items[index].item_id).common_violation"
                                                    v-for="(violation, id) in violations(items[index].item_id).common_violation"
                                                    :value="violation.id"
                                                >
                                                    {{ violation.definition }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-lg-2 col-12 my-lg-0 my-2">
                                            <p class="card-text col-title mb-md-2 mb-0">Cost</p>
                                            <input
                                                v-model="items[index].cost"
                                                type="text"
                                                class="form-control"
                                                placeholder="24"
                                                required
                                            />
                                        </div>
                                        <div class="col-lg-2 col-12 my-lg-0 my-2">
                                            <p class="card-text col-title mb-md-2 mb-0">Quantity</p>
                                            <input
                                                v-model="items[index].quantity"
                                                type="number"
                                                class="form-control"
                                                placeholder="1"
                                                required
                                            />
                                        </div>
                                        <div class="col-lg-2 col-12 mt-lg-0 mt-2">
                                            <p class="card-text col-title mb-md-50 mb-0">Price</p>
                                            <p class="card-text mb-0">$ {{ price(index) }}</p>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column align-items-center justify-content-between border-left invoice-product-actions py-50 px-25">
                                        <vue-feather @click="removeItem(index)" type="x" size="12" class="cursor-pointer"></vue-feather>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-1">
                                <div class="col-12 px-0">
                                    <button @click="addItem" type="button" class="btn btn-primary btn-sm btn-add-new">
                                        <vue-feather type="plus" size="12" class="mr-25"></vue-feather>
                                        <span class="align-middle">Add Item</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body invoice-padding">
                        <div class="row invoice-sales-total-wrapper">
                            <div class="offset-md-6 col-md-6 d-flex justify-content-end order-md-2 order-1">
                                <div class="invoice-total-wrapper">
                                    <div class="invoice-total-item">
                                        <p class="invoice-total-title">Total:</p>
                                        <p class="invoice-total-amount">$ {{ total }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="invoice-spacing mt-0" />
                    <div class="card-body invoice-padding py-0">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group mb-2">
                                    <label for="note" class="form-label font-weight-bold">Terms:</label>
                                    <textarea
                                        class="form-control"
                                        rows="2"
                                        id="note"
                                        readonly
                                    >
                                        PAYMENT DUE UPON RECEIPT BY CHECK TO NAME AND ADDRESS NOTATED ABOVE. IF PAYMENT IS NOT REMITTED IN 20 DAYS, LATE FEES MAY INCUR AND A COMPLAINT CONCERNING UNFAIR AND DECEPTIVE COLLECTION PRACTICES MAY BE REFERRED TO THE BUREAU, THE BBB, AND/OR ATTORNEY GENERAL
                                    </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-md-4 col-12">
                <div class="card">
                    <div class="card-body">
                        <button @click="createInvoice" type="button" class="btn btn-outline-primary btn-block">
                            Save
                        </button>
                        <button
                            v-if="this.$route.params && this.$route.params.client"
                            class="btn btn-primary btn-block mb-75"
                            @click="invoiceStore.type = 1"   
                        >
                            Cancel
                        </button>
                        <router-link
                            v-else
                            :to="{ name: 'invoice-list' }"
                            class="btn btn-primary btn-block mb-75"
                        >
                            Cancel
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped>
    .pagination {
        display: flex;
        margin: 0.25rem 0.25rem 0;
    }
    .pagination button {
        flex-grow: 1;
    }
    .pagination button:hover {
        cursor: pointer;
    }
</style>
<script>
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useInvoiceStore } from '../../stores/InvoiceStore.js'
    import vSelect from 'vue-select'
    import { ref, reactive } from 'vue'
    import { fix, round, chain, divide, ceil, multiply, sum } from 'mathjs'
    export default {
        mounted() {
            this.getDebtCollectors();
        },
        components: {
            vSelect
        },
        data() {
            return {
                items: [{
                    item_id: null,
                    cost: 0,
                    quantity: 0,
                    common_violation_id: null
                }]
            }
        },
        setup() {
            return {
                localizationStore: useLocalizationStore(),
                userStore: useUserStore(),
                invoiceStore: useInvoiceStore(),
                options: reactive([]),
                search: ref(''),
                page: ref(1),
                hasNextPage: ref(true),
                selected: ref(null)
            }
        },
        computed: {
            price()
            {
                return (index) => {
                    return fix(
                        multiply(
                            this.items[index].cost,
                            this.items[index].quantity
                        )
                    , 2);
                }
            },
            total()
            {
                let total = 0,
                $this = this;
                _.forEach(this.items, function(item, index) {
                    total = fix(sum(total, $this.price(index)),2)
                });
                return total;
            },
            violations()
            {
                return (id) => {
                    return _.find(this.invoiceStore.invoice.items, {id});
                }
            }
        },
        methods: {
            createInvoice() {
                let params = {};
                if (this.$route.params && this.$route.params.client) {
                    params.client = this.$route.params.client;
                    params.team = this.$route.params.team;
                }
                const route = this.$router.resolve(
                    {
                        name: 'invoice-save',
                        params: params
                    }
                );
                let $this = this;
                axios.post(
                    route.href,
                    {
                        items: $this.items,
                        credit_contact_id: $this.selected ? $this.selected.id : '',
                        invoice_no: $this.invoiceStore.invoice.invoiceNumber
                    }
                ).then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                    setTimeout(() => {
                        window.location.href = response.data.data.url;
                    }, 3000)
                    return;
                }).catch(function(error) {
                    toastr.error(error.response.data.response_msg, 'Error!');
                });
            },
            onSearch(query) {
                this.search = query
                this.page = 1
                this.getDebtCollectors()
            },
            next() {
                this.page += 1;
                this.getDebtCollectors()
            },
            previous() {
                this.page -= 1;
                this.getDebtCollectors()
            },
            getDebtCollectors() {
                let params = {};
                if (this.$route.params && this.$route.params.client) {
                    params.client = this.$route.params.client;
                }
                const route = this.$router.resolve(
                    {
                        name: 'invoice-debt-collectors',
                        params: params
                    }
                );
                let $this = this;
                axios.get(
                    route.href,
                    {
                        params: {
                            page: $this.page,
                            search: $this.search
                        }
                    }
                ).then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    $this.options.length = 0;
                    Object.assign($this.options, response.data.results);
                    $this.hasNextPage = response.data.pagination.more;
                    return;
                }).catch(function(error) {
                    toastr.error(error.response.data.response_msg, 'Error!');
                });
            },
            addItem: function () {
                this.items.push({
                    item_id: null,
                    cost: 0,
                    quantity: 0,
                    common_violation_id: null
                });
            },
            removeItem: function (index) {
                this.items = _.filter(this.items, function(item, key) {
                    if (index != key) {
                        return item;
                    }
                });
            }
        }
    }
</script>
